



























































































































































































import { isViewAsSelected } from "@/store/modules/TargetUserModule";
import { Component, Model, Prop, Vue, Watch } from "vue-property-decorator";
import { getIresDeviceCategory, getIresDeviceDisplayName, IresDevice, IresDeviceCategory } from "@/data/models/IresDevice";
import {
  getHyDryEventCategoryDescription,
  getHyDryEventMessageDescription,
  getHyDryPanelEventNumber,
  HyDryEventMessage,
  HyDryPanelEvent,
  UnreadHyDryEventMessagesInfo,
} from "@/data/models/HyDryEvent";
import {
  formatDate,
  formatDateHoursMinutes,
  formatDayOfTheWeekForDate,
} from "@/utils/DateFormatter";
import { deleteAllHyDryEventMessagesForSerialNumber } from "@/data/repository/HyDryEventsRepository";
import StateButtonComponent, { ButtonState } from "../common/StateButton.vue";
import router from "@/router/router";
import {
  DeviceFilter,
  matchesIresDeviceFilter,
} from "@/data/models/DeviceFilter";
import {
  COLOR_HY_DRY_DEVICE_ASSIGNMENT_LINK,
  COLOR_PROJECT_ASSIGNMENT_LINK,
  COLOR_SELECTED_ITEM_BACKGROUND,
  COLOR_SELECTED_ITEM_BACKGROUND_DARK,
  COLOR_WHITE_BACKGROUND,
  COLOR_WHITE_BACKGROUND_DARK,
} from "@/utils/colors";
import { themed, themedFill } from "@/utils/Theme";
import { isProjectNumberSameAsName } from "@/utils/ProjectNameCalculation";
import { areDatesOnSameDay } from "@/utils/DateHelper";
import {
  compareHyDryEventLogs,
  loadUnreadLogsOfCategories,
} from "@/data/repository/HyDryLogsRepository";
import { createHyDryMessageFromHyDryLog } from "@/data/models/HyDryEventLog";
import { getProjectManagementType } from "@/data/repository/ClientRepository";
import { ProjectManagement } from "@/data/models/Client";
import { hasCapability, DeviceCapability } from "@/data/models/DeviceCapability";
import { ComBox } from "@/data/models/ComBox";

enum MessagesToDisplayMode {
  LATEST_MESSAGE,
  ALL_MESSAGES,
}

@Component({
  components: {
    "state-button": StateButtonComponent,
  },
})
export default class HyDryEventMessageItemComponent extends Vue {
  /** Nothing may be changed while "Sicht auf" is active (ticket 2610051). */
  get isViewAsReadOnly() {
    return isViewAsSelected();
  }

  @Prop()
  iresDevice!: IresDevice;

  @Prop()
  unreadMessages!: UnreadHyDryEventMessagesInfo[];

  allMessages: UnreadHyDryEventMessagesInfo[] = [];

  @Model("change")
  selectedSerialNumber!: string;

  logsStartingFrom = new Date("2023/08/05");
  mode = MessagesToDisplayMode.LATEST_MESSAGE;

  numUnreadMessagesWhenLastLoadedAllMessages = -1;
  isLoadingAllMessages = false;

  projectNameExists = false;
  projectNumberExists = false;

  get firstLine() {
    if (this.projectName && this.projectName !== "") {
      this.projectNameExists = true;

      return this.projectName;
    }
    else if (this.projectNumber && this.projectNumber !== "") {
      this.projectNameExists = true;

      return this.projectNumber;
    }

    return "";
  }

  get secondLine() {
    if (
      this.projectNumberExists &&
      !isProjectNumberSameAsName(this.projectNumber, this.projectName)
    ) {
      return this.projectNumber;
    }

    return "";
  }

  @Watch("mode")
  async onMessagesToDisplayModeChanged(newMode: MessagesToDisplayMode) {
    if (newMode === MessagesToDisplayMode.ALL_MESSAGES) {
      this.$emit("change", this.iresDevice.serialNo);
      this.loadAllMessagesIfNeeded(true);
    }
  }

  @Watch("unreadMessages")
  async onUnreadMessagesChanged(
    after: UnreadHyDryEventMessagesInfo[],
    before: UnreadHyDryEventMessagesInfo[]
  ) {
    if (
      this.isShowingAllMessages &&
      after &&
      before &&
      this.calculateNumUnreadMessages(before) !==
        this.calculateNumUnreadMessages(after)
    ) {
      this.loadAllMessagesIfNeeded(false);
    }
  }

  async loadAllMessagesIfNeeded(showLoading: boolean) {
    const numUnreadMessages = this.numUnreadMessages;
    const isPanel = this.isPanel;
    

    if (this.numUnreadMessagesWhenLastLoadedAllMessages !== numUnreadMessages) {
      this.numUnreadMessagesWhenLastLoadedAllMessages = numUnreadMessages;

      if (numUnreadMessages <= 1) {
        this.allMessages = this.unreadMessages.slice(0, 1);
        return;
      }

      if (showLoading) {
        this.allMessages = [];
      }

      this.isLoadingAllMessages = showLoading;

      const logs = await loadUnreadLogsOfCategories(
        this.iresDevice.serialNo,
        this.unreadMessages
      );

      this.allMessages = logs
        .sort((a, b) => compareHyDryEventLogs(a, b))
        .map((log) => {
          return {
            eventCategory: log.eventCategory,
            numUnread: 1,
            latestMessage: createHyDryMessageFromHyDryLog(
              this.iresDevice.serialNo,
              log
            ),
          };
        })
        .filter((message) => {
          if (!isPanel) {
            return true;
          }

          return message.latestMessage.messageDate >= this.logsStartingFrom && message.latestMessage.eventNumber !== getHyDryPanelEventNumber(HyDryPanelEvent.STEP);
        });

      this.isLoadingAllMessages = false;
    }
  }

  @Watch("selectedSerialNumber")
  onSelectedSerialNumberChanged(newSelectedSerialNumber: string) {
    if (
      this.mode === MessagesToDisplayMode.ALL_MESSAGES &&
      this.iresDevice.serialNo !== newSelectedSerialNumber
    ) {
      this.mode = MessagesToDisplayMode.LATEST_MESSAGE;
    }
  }

  /** Getters rather than fields, so a theme switch repaints the cards with their dark palette shade. */
  get hyDryDeviceAssignmentCardColor() {
    return themedFill(COLOR_HY_DRY_DEVICE_ASSIGNMENT_LINK);
  }

  get projectAssignmentCardColor() {
    return themedFill(COLOR_PROJECT_ASSIGNMENT_LINK);
  }

  navigationButtonState = ButtonState.LINK;

  get cardColor() {
    return this.isShowingAllMessages
      ? themed(COLOR_SELECTED_ITEM_BACKGROUND, COLOR_SELECTED_ITEM_BACKGROUND_DARK)
      : themed(COLOR_WHITE_BACKGROUND, COLOR_WHITE_BACKGROUND_DARK);
  }

  get isShowingAllMessages() {
    return this.mode === MessagesToDisplayMode.ALL_MESSAGES;
  }

  /** Phone layout (below 600 px): caption, full-width text, then the chips and GELESEN. */
  get isPhone() {
    return this.$vuetify.breakpoint.xsOnly;
  }

  /** The phone row's caption: "10:50 · Orga · +17", the count only while collapsed. */
  getPhoneMessageCaption(messageInfo: UnreadHyDryEventMessagesInfo) {
    return [
      this.getFormattedMessageDate(messageInfo.latestMessage),
      this.getMessageEventCategory(messageInfo.latestMessage),
      this.isShowingAllMessages ? null : this.moreMessagesInfo,
    ]
      .filter((part) => !!part)
      .join(" · ");
  }

  get messagesToDisplay() {
    return this.isShowingAllMessages
      ? this.allMessages
      : [this.unreadMessages[0]];
  }

  get deviceName() {
    return getIresDeviceDisplayName(this.iresDevice);
  }

  get latestMessage(): HyDryEventMessage {
    return this.unreadMessages[0].latestMessage;
  }

  get messageDate() {
    return formatDateHoursMinutes(this.latestMessage.messageDate);
  }

  calculateNumUnreadMessages(unreadMessages: UnreadHyDryEventMessagesInfo[]) {
    let numUnreadMessages = 0;

    unreadMessages.forEach((m) => {
      numUnreadMessages += m.numUnread;
    });

    return numUnreadMessages;
  }

  get numUnreadMessages() {
    return this.calculateNumUnreadMessages(this.unreadMessages);
  }

  get moreMessagesInfo() {
    const numUnreadMessages = this.numUnreadMessages;

    if (numUnreadMessages <= 1) {
      return null;
    }

    return this.$t("messages.formatMoreMessages", [numUnreadMessages - 1]);
  }

  get isPanel() {
    return this.iresDevice ? getIresDeviceCategory(this.iresDevice) === IresDeviceCategory.PANEL : false;
  }

  // ==================== FIRMWARE v4.0.0+ CHANGES ====================
  get doesSupportExtendedSensors() {
    if (this.isPanel) {
      return false;
    }

    return hasCapability(this.iresDevice as ComBox, DeviceCapability.EXTENDED_SENSORS);
  }

  getFormattedMessageDate(message: HyDryEventMessage) {
    const messageDate = message.messageDate;

    if (this.mode === MessagesToDisplayMode.ALL_MESSAGES) {
      return formatDateHoursMinutes(messageDate);
    }

    const ref = new Date();

    //Today
    if (areDatesOnSameDay(ref, messageDate)) {
      return formatDate(messageDate, "HH:mm");
    }

    ref.setDate(ref.getDate() - 1);

    //Yesterday
    if (areDatesOnSameDay(ref, messageDate)) {
      return this.$t("messages.yesterday");
    }

    const dayOfWeek = formatDayOfTheWeekForDate(this, messageDate);

    return `${dayOfWeek} ${formatDate(messageDate, "dd.MM.")}`;
  }

  getMessageDescription(message: HyDryEventMessage) {
    const isPanel = this.isPanel;
    return getHyDryEventMessageDescription(this, message, isPanel, true, this.doesSupportExtendedSensors);
  }

  getMessageEventCategory(message: HyDryEventMessage) {
    return getHyDryEventCategoryDescription(this, message.eventCategory);
  }

  get isIresDeviceAssignedToProject() {
    return !!this.iresDevice.currentAssignment?.currentProjectId;
  }

  get projectName() {
    return this.iresDevice.currentAssignment?.currentProjectName;
  }

  get projectNumber() {
    return this.iresDevice.currentAssignment?.currentProjectNumber;
  }

  get dryingNumber() {
    const latestProgramChainNumber = this.iresDevice.programChainData
      ?.latestProgramChainNumber;

    if (!latestProgramChainNumber) {
      return "";
    }

    return this.$t("messages.formatDrying", [latestProgramChainNumber]);
  }

  async onMarkAsRead() {
    await deleteAllHyDryEventMessagesForSerialNumber(
      this.iresDevice.serialNo,
      this.unreadMessages.map((info) => info.eventCategory)
    );
  }

  onShowLatestMessage() {
    this.mode = MessagesToDisplayMode.LATEST_MESSAGE;
  }

  onToggleMessagesToDisplay() {
    this.mode = this.isShowingAllMessages
      ? MessagesToDisplayMode.LATEST_MESSAGE
      : MessagesToDisplayMode.ALL_MESSAGES;
  }

  onOpenDeviceDetails() {
    const isDeviceInUsage = matchesIresDeviceFilter(
      DeviceFilter.IN_USAGE,
      this.iresDevice,
      null
    );

    router.push({
      path: isDeviceInUsage
        ? `/main/devices/deviceDetail`
        : `/main/devices/dryingHistory`,
      query: {
        serialNumber: this.iresDevice.serialNo,
      },
    });

    this.mode = MessagesToDisplayMode.ALL_MESSAGES;
  }

  onOpenProjectDetails() {
    if (getProjectManagementType() === ProjectManagement.DEVICES_ONLY_WEBSITE) {
      return;
    }

    const projectId = this.iresDevice.currentAssignment?.currentProjectId;

    if (!projectId) {
      return;
    }

    router.push({
      path: `/main/projects/${projectId}`,
    });

    this.mode = MessagesToDisplayMode.ALL_MESSAGES;
  }
}
